export default "__VITE_ASSET__C0001jsR__"